import { render, staticRenderFns } from "./bigScreenExam.vue?vue&type=template&id=57fac1d0&scoped=true"
import script from "./bigScreenExam.vue?vue&type=script&lang=js"
export * from "./bigScreenExam.vue?vue&type=script&lang=js"
import style0 from "./bigScreenExam.vue?vue&type=style&index=0&id=57fac1d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fac1d0",
  null
  
)

export default component.exports